import React from 'react';

import { ArticleHeading4, ArticleParagraph2 } from '@cian/ui-kit';

import styles from './styles.css';
import { useSelector } from 'react-redux';
import { selectCalculatorValues } from 'shared/subsidizedCalculator/selectors/selectCalculatorValues';
import { NBSP } from '../../../common/constants';

export const Footer: React.FC = () => {
  const calculatorState = useSelector(selectCalculatorValues);
  const discountMortgageTerm = calculatorState.discountMortgageTerm;

  return (
    <div>
      <div className={styles['text']}>
        <div className={styles['title']}>
          <ArticleHeading4>
            Пониженная ставка и платёж — на {discountMortgageTerm}
            {NBSP}года
          </ArticleHeading4>
        </div>
        <ArticleParagraph2>
          Берите ипотеку со скидкой сейчас, а через {discountMortgageTerm} года сможете переоформить{NBSP}её на{NBSP}
          новых условиях. <br />
          Нужно подтверждение дохода и{NBSP}страхование.
        </ArticleParagraph2>
      </div>
    </div>
  );
};
